import { relations, sql } from 'drizzle-orm';
import { check, index, integer, pgTable, serial, timestamp, uniqueIndex, varchar } from 'drizzle-orm/pg-core';
import { typeIdDataType as typeId } from '../utils/typeid';
import { user } from './user';

export const dashboardSession = pgTable(
  'dashboard_session',
  {
    id: serial().primaryKey(),
    public_id: typeId('dashboardSession', 'public_id').notNull(),
    user_id: integer()
      .notNull()
      .references(() => user.id, { onDelete: 'cascade' }),
    // SHA-256 hex digest of the cookie secret; never store the secret itself.
    token_hash: varchar({ length: 64 }).notNull(),
    created_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
    last_activity_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
    last_authenticated_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
    // Absolute deadline set at creation; activity must not extend it.
    expires_at: timestamp({ withTimezone: true, mode: 'string' }).notNull(),
    user_agent: varchar({ length: 1024 }),
  },
  (t) => [
    uniqueIndex('dashboard_session_public_id_uq').on(t.public_id),
    uniqueIndex('dashboard_session_token_hash_uq').on(t.token_hash),
    index('dashboard_session_user_id_idx').on(t.user_id),
    index('dashboard_session_expires_at_idx').on(t.expires_at),
    index('dashboard_session_last_activity_at_idx').on(t.last_activity_at),
    check('dashboard_session_token_hash_format_ck', sql`${t.token_hash} ~ '^[0-9a-f]{64}$'`),
    check('dashboard_session_expiration_ck', sql`${t.expires_at} > ${t.created_at}`),
    check(
      'dashboard_session_activity_ck',
      sql`${t.last_activity_at} >= ${t.created_at} AND ${t.last_activity_at} <= ${t.expires_at}`,
    ),
  ],
);

export const dashboardSessionRelations = relations(dashboardSession, ({ one }) => ({
  user: one(user, { fields: [dashboardSession.user_id], references: [user.id] }),
}));
